import { z } from "zod";

/** A real-time activity timer; null clears it. It never changes playback speed or beat length. */
export const zStoryTimerCue = z.object({
  kind: z.literal("timer"),
  seconds: z.number().int().min(1).max(3600).nullable(),
  label: z.string().min(1).max(60).optional(),
}).strict();
export type StoryTimerCue = z.infer<typeof zStoryTimerCue>;
